import { Helpers } from '../../helpers';
import { ICostCodeCategory } from '../../interfaces/icost-code-category';
import { CostCode } from '../cost-code';

export class CostCodeCategoryBase {
  CostCodeCategoryId: number;
  CostCodeCategoryDescription: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  CostCodes_CostCodeCategory?: Array<CostCode> | null;

  constructor(item?: ICostCodeCategory) {
    if (item) {

      this.CostCodeCategoryId = item.CostCodeCategoryId;
      this.CostCodeCategoryDescription = item.CostCodeCategoryDescription;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.CostCodes_CostCodeCategory = Helpers.createClassArray(CostCode, item.CostCodes_CostCodeCategory);
    }
  }
}